import {
  Box,
  TransparentButton,
  Typography,
  VerticalDivider,
} from '@ttx/design-system';
import React, {FC} from 'react';

interface IQuantitySelector {
  onIncrement: () => void;
  onDecrement: () => void;
  quantity: number;
  isMobile?: boolean;
  hideQtyButton?: boolean;
}

export const QuantitySelector: FC<IQuantitySelector> = ({
  onIncrement,
  onDecrement,
  quantity,
  isMobile,
  hideQtyButton,
}) => {
  return (
    <Box marginTop="seven">
      <Box
        width="100px"
        height={isMobile ? '48px' : '25px'}
        alignItems={isMobile ? 'flex-start' : 'center'}
        paddingTop={isMobile ? 'three' : 'one'}
      >
        <Typography textStyle="s" color="textLow" textAlign="right">
          {isMobile ? 'Quantity:' : 'Qty'}
        </Typography>
      </Box>
      {hideQtyButton && (
        <Box
          flexDirection="row"
          width="fit-content"
          right="0px"
          position="absolute"
          height={isMobile ? '48px' : '25px'}
        >
          <Box
            width={['48px', '25px']}
            height="25px"
            alignItems="center"
            paddingTop={isMobile ? 'three' : 'one'}
          >
            <Typography textStyle="s" color="textDefault">
              X {quantity}
            </Typography>
          </Box>
        </Box>
      )}
      {!hideQtyButton && (
        <Box
          flexDirection="row"
          borderColor="outlines"
          borderWidth="one"
          borderStyle="solid"
          borderRadius="one"
          width="fit-content"
          right="0px"
          position="absolute"
          height={isMobile ? '48px' : '25px'}
        >
          <TransparentButton
            css={{
              width: isMobile ? '48px' : '25px',
              height: isMobile ? '48px' : '25px',
            }}
            onPress={onDecrement}
            style={{
              justifyContent: 'center',
            }}
          >
            <Box width={['eleven', 'eight']}>
              <Typography textStyle="s" color="textDefault" textAlign="center">
                -
              </Typography>
            </Box>
          </TransparentButton>
          <VerticalDivider />
          <Box
            width={['48px', '25px']}
            // height={['48px', '25px']}
            alignItems="center"
            paddingTop={['zero', 'one']}
            css={{
              alignSelf: 'center',
            }}
          >
            <Typography textStyle="s" color="textDefault">
              {quantity}
            </Typography>
          </Box>
          <VerticalDivider />
          <TransparentButton
            css={{
              width: isMobile ? '48px' : '25px',
              height: isMobile ? '48px' : '25px',
            }}
            onPress={onIncrement}
            style={{justifyContent: 'center'}}
          >
            <Box width={['eleven', 'eight']} alignItems="center">
              <Typography textStyle="s" color="textDefault" textAlign="center">
                +
              </Typography>
            </Box>
          </TransparentButton>
        </Box>
      )}
    </Box>
  );
};
